// @flow
import React from 'react'
import IconStar from './IconStar'

type Props = {
  favourite?: boolean
}

export default class IconFavourite extends React.Component<Props> {
  // TODO: enable starring project here
  fill () {
    return this.props.favourite ? 'gray' : 'white'
  }

  render () {
    return <IconStar
      {...this.props}
      stroke='gray'
      fill={this.fill()}
    />
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/icons/IconFavourite.js